import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag } from "lucide-react";
import { PortalShell } from "@/components/PortalShell";
import api from "@/lib/api";
import { formatDateTimeAU } from "@/lib/formatDateAU";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/trade/orders").then(({ data }) => setOrders(data)).finally(() => setLoading(false));
  }, []);

  return (
    <PortalShell title="Your trade orders" subtitle="Order history">
      {loading ? (
        <div className="text-slate-500">Loading orders...</div>
      ) : orders.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-3xl border border-slate-200">
          <p className="text-slate-600">No orders yet.</p>
          <Link to="/trade/order" className="mt-3 inline-block font-semibold text-cyan-600 hover:underline">Place your first order →</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-2xl border border-slate-200 p-5 hover:shadow-md transition-shadow">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="font-mono text-sm font-bold text-slate-900">{o.reference}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{formatDateTimeAU(o.created_at)}</div>
                </div>
                <span className="px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 text-xs font-semibold capitalize">{o.status}</span>
              </div>
              <div className="mt-3 grid sm:grid-cols-3 gap-3 text-sm">
                <div>
                  <div className="text-[10px] uppercase tracking-wider font-bold text-slate-400">Test</div>
                  <div className="text-slate-900 font-medium">{o.test_name}</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-wider font-bold text-slate-400">Quantity</div>
                  <div className="text-slate-900 font-medium">{o.quantity}</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-wider font-bold text-slate-400">Total</div>
                  <div className="text-slate-900 font-bold">${o.total.toFixed(2)}</div>
                </div>
                <div className="sm:col-span-2">
                  <div className="text-[10px] uppercase tracking-wider font-bold text-slate-400">Client</div>
                  <div className="text-slate-700">{o.client_name} — {o.client_address}</div>
                </div>
                {o.white_label && (
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-900 text-cyan-300 text-[10px] font-bold uppercase tracking-wider w-fit">
                    <Tag className="w-3 h-3" /> White label
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </PortalShell>
  );
}
